import {MUIProLicense} from "@bounce/shared/constants";
import {ThemeConfig, Toast} from "@bounce/shared/ui";
import NiceModal from "@ebay/nice-modal-react";
import {LicenseInfo} from "@mui/x-license";
import {QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import React from "react";
import {BrowserRouter} from "react-router-dom";
import Router from "routes/routes";
import ServerApiExceptionManager from "./api/ServerApiExceptionManager";
import ServerApiManager, {queryClient} from "./api/ServerApiManager";
import {AmplitudeProvider} from "./contexts/AmplitudeContext";
import {AuthProvider} from "./contexts/AuthContext";
import {PartnerProvider} from "./contexts/PartnerContext";
import {SentryProvider} from "./contexts/SentryContext";
import palette from "./ui/palette";

function App() {
  LicenseInfo.setLicenseKey(MUIProLicense);
  return (
    <BrowserRouter future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
      <QueryClientProvider client={queryClient}>
        <ThemeConfig palette={palette}>
          <Toast />
          <AuthProvider>
            <ServerApiManager />
            <PartnerProvider>
              <AmplitudeProvider>
                <SentryProvider>
                  <ReactQueryDevtools initialIsOpen={false} />
                  <ServerApiExceptionManager />
                  <NiceModal.Provider>
                    <Router />
                  </NiceModal.Provider>
                </SentryProvider>
              </AmplitudeProvider>
            </PartnerProvider>
          </AuthProvider>
        </ThemeConfig>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
